import { render, staticRenderFns } from "./SpinnersPage.vue?vue&type=template&id=d8359d7c&scoped=true&"
import script from "./SpinnersPage.vue?vue&type=script&lang=js&"
export * from "./SpinnersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8359d7c",
  null
  
)

export default component.exports